/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
// CONSTANTS are all caps.
const NS = 'IwpApplicationForm';
const CLS = 'iwpApplicationForm';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/iwpApplicationForm.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class IwpApplicationForm {
	constructor($el) {
		// $el is the widget node return by the loadIwpApplicationForm function
		this.$el = $el;
		this.element = $el;
		this.$element = $(this.$el);
		this.$sections = this.$element.find('.Form__Element.FormStep');
		this.$form = this.$element.find('form');
		this.$navs = this.$element.find(WG + 'navigator');
		this.$navSteps = this.$element.find(WG + 'navs-step');
		this.$navsTitle = this.$element.find(WG + 'navs-title');
		this.headerOffset = ($('.siteHeader').length > 0) ? $('.siteHeader').height() : 0;
		this.$mobileStepCount = this.$element.find(WG + 'mobile-steps .current-step');

		this.setActiveSection(parseInt($(`[name="__FormCurrentStepIndex"]`).val()) || 0, true);
	}

	init() {
		this.$element.find(`.${CLS}-pagination .page-link--previous`).on('click', () => {
			setTimeout(() => {
				let previous = parseInt($(`[name="__FormCurrentStepIndex"]`).val()) || 0;
				this.setActiveSection(previous);
			}, 250);
		});

		this.$element.find(`.${CLS}-pagination .page-link--next`).on('click', () => {
			setTimeout(() => {
				let next = parseInt($(`[name="__FormCurrentStepIndex"]`).val()) || 0;
				this.setActiveSection(next);
			}, 250);
		});
	}

	setActiveSection(activeIndex, initLoad = false) {
		this.$element.find(`.${CLS}-navs-step`)
			.removeClass('active')
			.eq(activeIndex)
			.addClass('active');

		this.$mobileStepCount.text(activeIndex + 1);

		// update the title
		this.$navsTitle.text(this.$element.find(`.${CLS}-navs-step`).eq(activeIndex).data('stepTitle'));

		// update active index
		this.$navs.attr('data-active-section-index', activeIndex);

		this.sectionActiveIndex = activeIndex;

		if (initLoad) {
			// scroll to top of the page
			$('html, body').animate({
				scrollTop: this.$element.closest('main').offset().top,
			}, 250);
		}
	}

	// Add more functions like on above here
}
